import {DocumentFrom} from "../../helper/enums";
import {request} from "../../helper/APIUtils";
import {showAxiosError} from "../../helper/helper";

export function modifyInvoice(outbox) {
    if(!outbox.givenName && !outbox.familyName && outbox.formattedName && outbox.vknTckn && outbox.vknTckn.length === 11) {
        let res = outbox.formattedName.split(' ');
        if (res.length > 1) {
            outbox.givenName = res.shift();
            outbox.familyName = res.join(' ');
            outbox.formattedName = null;
        }
    }

    if(outbox["documentNumber"]!== undefined && outbox["documentNumber"]!== null){
        outbox["documentNumber"] = ('' + outbox["documentNumber"]).trim();
    }

    outbox["issueDate"] = outbox.issueDate.replace(" ", "T");
    outbox["tmpDocConnectorExCustomer"] = {
        vknTckn: outbox.vknTckn,
        formattedName: outbox.formattedName === null ? "" : outbox.formattedName,
        givenName: outbox.givenName,
        familyName: outbox.familyName,
        city: outbox.city,
        cityName: outbox.cityName,
        citySubdivisionName: outbox.citySubdivisionName,
        countryName: outbox.countryName,
        streetName:outbox.streetName,
        postalZone: outbox.postalZone,
        telephone: outbox.telephone,
        webSite: outbox.webSite,
        email:outbox.email,
        fax: outbox.fax,
        taxOffice:outbox.taxOffice,
        postboxAlias:outbox.postboxAlias,
        gbAlias: outbox.gbAlias,
        mersisNumber: outbox.mersisNumber,
        tradeRegistrationNumber: outbox.tradeRegistrationNumber,
        tabdkNo: outbox.tabdkNo
    };
    if (outbox.agentPartyVknTckn) {
        outbox["tmpDocInvoiceAgentParty"] = {
            vknTckn: outbox.agentPartyVknTckn,
            formattedName: outbox.agentPartyFormattedName === null ? "" : outbox.formattedName,
            cityName: outbox.agentPartyCityName,
            citySubdivisionName: outbox.agentPartyCitySubdivisionName,
            countryName: outbox.countryName === null ? "Türkiye" : outbox.countryName,
            streetName: outbox.agentPartyStreetName,
            postalZone: outbox.agentPartyPostalZone,
            telephone: outbox.agentPartyPhone,
            webSite: outbox.agentPartyWebSite,
            email: outbox.agentPartyEmail,
            fax: outbox.agentPartyFax,
            taxOffice: outbox.agentPartyTaxOffice,
            building_name: outbox.agentPartyBuildingName,
            building_no: outbox.agentPartyBuildingNo
        };
    }
    if(outbox.profileId == "IHRACAT"){
        if(outbox.vknTckn.length === 11){
            outbox["tmpDocConnectorExCustomer"].buyerType = 'OZEL';
        }else if(outbox.vknTckn.length === 10){
            outbox["tmpDocConnectorExCustomer"].buyerType = 'TUZEL';
        }
    }

    if (outbox.invoiceTypeCode === "IADE") {
        let referenceStr = outbox.iadeInvoiceReferenceId || "";

        outbox["trdDocInvoiceIadeLines"] = referenceStr
            .split(";")
            .filter(entry => entry.includes(","))
            .map(entry => {
                let [invoiceNumber, rawDate] = entry.split(",");
                let isValidDateFormat = /^\d{4}-\d{2}-\d{2}$/.test(rawDate);

                let issueDate = isValidDateFormat ? rawDate + "T00:00:00" : null;

                return { invoiceNumber, issueDate };
            });
    }

    outbox["retailCustomer"] = false;
    outbox["trdDocExternalCustomer"]=null;

    outbox["trdDocInvoiceNotes"]= [
        {note:outbox.note!= null ?outbox.note:'',recordId: null},
        {note:outbox.note1!= null ?outbox.note1: '',recordId: null},
        {note:outbox.note2!= null ?outbox.note2: '',recordId: null},
        {note:outbox.note3!= null ?outbox.note3: '',recordId: null},
        {note:outbox.note4!= null ?outbox.note4: '',recordId: null},
        {note:outbox.note5!= null ?outbox.note5: '',recordId: null},
        {note:outbox.note6!= null ?outbox.note6: '',recordId: null},
        {note:outbox.note7!= null ?outbox.note7: '',recordId: null},
        {note:outbox.note8!= null ?outbox.note8: '',recordId: null},
        {note:outbox.note9!= null ?outbox.note9: '',recordId: null},
        {note:outbox.note10!= null ?outbox.note10: '',recordId: null},
        {note:outbox.note11!= null ?outbox.note11: '',recordId: null},
        {note:outbox.note12!= null ?outbox.note12: '',recordId: null},
        {note:outbox.note13!= null ?outbox.note13: '',recordId: null},
        {note:outbox.note14!= null ?outbox.note14: '',recordId: null},
        {note:outbox.note15!= null ?outbox.note15: '',recordId: null}
    ];

    outbox.trdDocInvoiceLines && outbox.trdDocInvoiceLines.map(line=>{
        line.trdDocInvoiceLineCharges = line.trdDocInvoiceLineCharges.map(charge=>{
            charge.taxCode = {};
            let tax = charge.taxCode;
            tax.code = charge.chargeCode;
            charge.taxCode = tax;
            delete charge.chargeCode;
            return charge;
        })
        if (["IHRACAT","IHRACKAYITLI"].includes(outbox.profileId)) {
            line["trdDocInvoiceLineDeliveryDetail"] = {
                actualPackageId: line.actualPackageId ? line.actualPackageId : null,
                actualPackagePTC: line.actualPackagePTC ? line.actualPackagePTC : null,
                actualPackageQuantity: line.actualPackageQuantity ? line.actualPackageQuantity : null,
                beyanEdilenKiymetDegeri: line.beyanEdilenKiymetDegeri ? line.beyanEdilenKiymetDegeri : null,
                buildingName: line.buildingName ? line.buildingName : null,
                buildingNumber: line.buildingNumber ? line.buildingNumber : null,
                city: line.city ? line.city : null,
                citySubdivion: line.citySubdivion ? line.citySubdivion : null,
                country: line.country ? line.country : null,
                declaredForCarriageValueAmount: line.declaredForCarriageValueAmount ? line.declaredForCarriageValueAmount : null,
                deliveryTerms: line.deliveryTerms ? line.deliveryTerms : null,
                gtip: line.gtip ? line.gtip : null,
                insuranceValueAmount: line.insuranceValueAmount ? line.insuranceValueAmount : null,
                packageBrand: line.packageBrand ? line.packageBrand : null,
                postalZone: line.postalZone ? line.postalZone : null,
                shipmentId: line.shipmentId ? line.shipmentId : null,
                streetName: line.streetName ? line.streetName : null,
                transportMeansTypeCode: line.transportMeansTypeCode ? line.transportMeansTypeCode : null,
                transportModeCode: line.transportModeCode ? line.transportModeCode : null
            }
            let lineDeliveryDetailKeys = [
                'actualPackageId', 'actualPackagePTC', 'actualPackageQuantity',
                'beyanEdilenKiymetDegeri', 'buildingName', 'buildingNumber',
                'city', 'citySubdivion', 'country',
                'declaredForCarriageValueAmount', 'deliveryTerms', 'gtip',
                'insuranceValueAmount', 'packageBrand', 'postalZone',
                'shipmentId', 'streetName', 'transportMeansTypeCode',
                'transportModeCode'
            ];
            lineDeliveryDetailKeys.forEach(key => delete line[key]);
        }
        return line;
    })
    outbox["trdDocInvoiceLines"]= outbox.trdDocInvoiceLines;
    outbox["taxCurrencyCode"]= outbox.documentCurrencyCode;
    outbox["paymentAlternativeCurrencyCode"]= outbox.documentCurrencyCode;
    if(outbox.internetSalesWebSite!=null && outbox.internetSalesWebSite.trim().length>0){
        outbox["trdDocInvoiceInternetSales"]= {
            documentType: outbox.internetSalesDocumentType==null?'DIGER':outbox.internetSalesDocumentType,
            documentId: outbox.internetSalesDocumentId==null?'INTERNET_SATIS':outbox.internetSalesDocumentId,
            issueDate: outbox.internetSalesIssueDate==null?outbox.issueDate:outbox.internetSalesIssueDate,
            webSite: outbox.internetSalesWebSite,
            documentTypeCode: outbox.internetSalesDocumentTypeCode==null?'ODEME_SEKLI':outbox.internetSalesDocumentTypeCode,
            description: outbox.internetSalesDescription
        };
        if(!outbox.carrierPartyFirstName && !outbox.carrierPartyFamilyName && outbox.carrierPartyName && outbox.carrierPartyName.length === 11) {
            let res = outbox.formattedName.split(' ');
            if (res.length > 1) {
                outbox.carrierPartyFirstName = res.shift();
                outbox.carrierPartyFamilyName = res.join(' ');
                outbox.carrierPartyName = null;
            }
        }
        // outbox.carrierPartyId Taşıyıcı Vkn
        // outbox.carrierPartyName Taşıyıcı Unvan
        // outbox.actualDeliveryDate Taşıyıcı Gönderim Tarihi
        // outbox.carrierPartyFirstName Taşıyıcı Adı
        // outbox.carrierPartyFamilyName Taşıyıcı Soyad

    }
    let referenceList= [];

    if (outbox.despatchReferenceId!=null && outbox.despatchReferenceIssueDate!=null &&
        outbox.despatchReferenceId.indexOf(',') > -1 && outbox.despatchReferenceIssueDate.indexOf(',') > -1) {
        let despatchIds = outbox.despatchReferenceId.trim().split(',');
        let despatchDates = outbox.despatchReferenceIssueDate.trim().split(',');

        despatchIds.forEach((despatchId,index)=>{
            referenceList.push({
                referenceId:despatchId.trim(),
                referenceIssueDate: despatchDates[index]!=null ? despatchDates[index].trim() : ''
            })
        })

        // remove duplicate values
        if(referenceList != null && referenceList.length>0){
            referenceList = referenceList.filter((v,i,a)=>a.findIndex(v2=>(JSON.stringify(v2) === JSON.stringify(v)))===i)
        }

    }else{
        referenceList= [{
            referenceId:outbox.despatchReferenceId,
            referenceIssueDate:outbox.despatchReferenceIssueDate
        }];
    }
    outbox["trdDocInvoiceDespatchReferences"] = referenceList;

    outbox["from"] = DocumentFrom.CONNECTOR;
    return outbox;
}

export function modifyDespatch(outbox) {
    if(!outbox.givenName && !outbox.familyName && outbox.formattedName && outbox.vknTckn && outbox.vknTckn.length === 11) {
        let res = outbox.formattedName.split(' ');
        if (res.length > 1) {
            outbox.givenName = res.shift();
            outbox.familyName = res.join(' ');
            outbox.formattedName = null;
        }
    }

    if(outbox["documentNumber"]!== undefined && outbox["documentNumber"]!== null){
        outbox["documentNumber"] = ('' + outbox["documentNumber"]).trim();
    }

    let hour = Math.trunc(outbox.docTime / 16777216) +"";
    let minute = Math.trunc((outbox.docTime % 16777216) / 65536)+"";
    let second = Math.trunc(((outbox.docTime % 16777216) % 65536 / 256))+"";

    let time = hour.padStart(2,"0") + ":" + minute.padStart(2,"0") + ":" +  second.padStart(2,"0")

    if(!outbox["issueDate"].includes("T")) {
        outbox["issueDate"] = outbox.issueDate + "T" + time;
    }

    outbox["tmpDocConnectorExCustomer"] = {
        vknTckn: outbox.vknTckn,
        formattedName: outbox.formattedName === null ? "" : outbox.formattedName,
        givenName: outbox.givenName,
        familyName: outbox.familyName,
        city: outbox.city,
        cityName: outbox.cityName,
        citySubdivisionName: outbox.citySubdivisionName,
        countryName: outbox.countryName,
        streetName:outbox.streetName,
        postalZone: outbox.postalZone,
        telephone: outbox.telephone,
        webSite: outbox.webSite,
        email:outbox.email,
        fax: outbox.fax,
        taxOffice:outbox.taxOffice,
        despatchPostboxAlias:outbox.despatchPostboxAlias,
        despatchGbAlias: outbox.despatchGbAlias,
        mersisNumber: outbox.mersisNumber,
        tradeRegistrationNumber: outbox.tradeRegistrationNumber,
        tabdkNo: outbox.tabdkNo,
    };

    let shipHour = Math.trunc(outbox.shipTime / 16777216) +"";
    let shipMinute = Math.trunc((outbox.shipTime % 16777216) / 65536)+"";
    let shipSecond = Math.trunc(((outbox.shipTime % 16777216) % 65536 / 256))+"";

    let shipTime = shipHour.padStart(2,"0") + ":" + shipMinute.padStart(2,"0") + ":" +  shipSecond.padStart(2,"0");
    let actualTime = outbox.shipDate + "T" + shipTime;

    if(outbox["despatchShipment"] && outbox["despatchShipment"]["actualDespatchDatetime"]) {
        actualTime =  outbox["despatchShipment"]["actualDespatchDatetime"];
    }

    outbox["despatchShipment"] = {
        actualDespatchDatetime: actualTime,
        carrierId:outbox.carrierId,
        carrierTitle: outbox.carrierTitle,
        deliveryType:outbox.deliveryType,
        deliveryCity:outbox.deliveryCity,
        deliveryCitySubdivision:outbox.deliveryCitySubdivision,
        deliveryCountry:outbox.deliveryCountry,
        deliveryPostalZone:outbox.deliveryPostalZone,
        deliveryRoomNumber:outbox.deliveryRoomNumber,
        deliveryStreet:outbox.deliveryStreet,
        transportId:outbox.transportId
    };

    if(outbox.deliveryType==='DRIVER'){
        outbox["despatchShipment"]["driverInfos"] = [
            {
                identityCardNo: outbox.driverTckn,
                familyName: outbox.driverFamilyName,
                firstName: outbox.driverFirstName
            }
        ];
    }

    outbox["isDespatchMixedCustomer"] =(
        outbox.vknTckn === 5555555555 ||
        outbox.vknTckn === "5555555555" ||
        outbox.vknTckn === 55555555555 ||
        outbox.vknTckn === "55555555555"
    );

    outbox["despatchNotes"]= [
        {note:outbox.note!= null ?outbox.note:'',recordId: null},
        {note:outbox.note1!= null ?outbox.note1: '',recordId: null},
        {note:outbox.note2!= null ?outbox.note2: '',recordId: null},
        {note:outbox.note3!= null ?outbox.note3: '',recordId: null},
        {note:outbox.note4!= null ?outbox.note4: '',recordId: null},
        {note:outbox.note5!= null ?outbox.note5: '',recordId: null},
        {note:outbox.note6!= null ?outbox.note6: '',recordId: null},
        {note:outbox.note7!= null ?outbox.note7: '',recordId: null},
        {note:outbox.note8!= null ?outbox.note8: '',recordId: null},
        {note:outbox.note9!= null ?outbox.note9: '',recordId: null},
        {note:outbox.note10!= null ?outbox.note10: '',recordId: null},
        {note:outbox.note11!= null ?outbox.note11: '',recordId: null},
        {note:outbox.note12!= null ?outbox.note12: '',recordId: null},
        {note:outbox.note13!= null ?outbox.note13: '',recordId: null},
        {note:outbox.note14!= null ?outbox.note14: '',recordId: null},
        {note:outbox.note15!= null ?outbox.note15: '',recordId: null}
    ];

    outbox["despatchLines"] = outbox.despatchLines;
    outbox["taxCurrencyCode"]= outbox.documentCurrencyCode;
    outbox["paymentAlternativeCurrencyCode"]= outbox.documentCurrencyCode;
    outbox["pricingCurrencyCode"]= outbox.documentCurrencyCode;

    outbox["from"] = DocumentFrom.CONNECTOR;

    return outbox;
}

export function modifyVoucher(outbox) {
    if(!outbox.givenName && !outbox.familyName && outbox.formattedName && outbox.vknTckn && outbox.vknTckn.length === 11) {
        let res = outbox.formattedName.split(' ');
        if (res.length > 1) {
            outbox.givenName = res.shift();
            outbox.familyName = res.join(' ');
            outbox.formattedName = null;
        }
    }

    if(outbox["documentNumber"]!== undefined && outbox["documentNumber"]!== null){
        outbox["documentNumber"] = ('' + outbox["documentNumber"]).trim();
    }

    if(!outbox["sendingType"]){
        outbox["sendingType"] = "ELEKTRONIK"
    }
    outbox["issueDate"] = outbox.issueDate.replace(" ", "T");
    outbox["tmpDocConnectorExCustomer"] = {
        vknTckn: outbox.vknTckn,
        formattedName: outbox.formattedName === null ? "" : outbox.formattedName,
        givenName: outbox.givenName,
        familyName: outbox.familyName,
        city: outbox.city,
        cityName: outbox.cityName,
        citySubdivisionName: outbox.citySubdivisionName,
        countryName: outbox.countryName,
        streetName:outbox.streetName,
        postalZone: outbox.postalZone,
        telephone: outbox.telephone,
        webSite: outbox.webSite,
        email:outbox.email,
        fax: outbox.fax,
        taxOffice:outbox.taxOffice,
        postboxAlias:outbox.postboxAlias,
        gbAlias: outbox.gbAlias,
        mersisNumber: outbox.mersisNumber,
        tradeRegistrationNumber: outbox.tradeRegistrationNumber,
        tabdkNo: outbox.tabdkNo
    };

    outbox["trdDocExternalCustomer"]=null;

    outbox["trdDocVoucherNotes"]= [
        {note:outbox.note!= null ?outbox.note:'',recordId: null},
        {note:outbox.note1!= null ?outbox.note1: '',recordId: null},
        {note:outbox.note2!= null ?outbox.note2: '',recordId: null},
        {note:outbox.note3!= null ?outbox.note3: '',recordId: null},
        {note:outbox.note4!= null ?outbox.note4: '',recordId: null},
        {note:outbox.note5!= null ?outbox.note5: '',recordId: null},
        {note:outbox.note6!= null ?outbox.note6: '',recordId: null},
        {note:outbox.note7!= null ?outbox.note7: '',recordId: null},
        {note:outbox.note8!= null ?outbox.note8: '',recordId: null},
        {note:outbox.note9!= null ?outbox.note9: '',recordId: null},
        {note:outbox.note10!= null ?outbox.note10: '',recordId: null},
        {note:outbox.note11!= null ?outbox.note11: '',recordId: null},
        {note:outbox.note12!= null ?outbox.note12: '',recordId: null},
        {note:outbox.note13!= null ?outbox.note13: '',recordId: null},
        {note:outbox.note14!= null ?outbox.note14: '',recordId: null},
        {note:outbox.note15!= null ?outbox.note15: '',recordId: null}
    ];

    outbox.trdDocVoucherLines && outbox.trdDocVoucherLines.map(line=>{
        if(line.trdDocVoucherLineCharges){
            line.trdDocVoucherLineCharges = line.trdDocVoucherLineCharges.map(charge=>{
                charge.taxCode = {};
                let tax = charge.taxCode;
                tax.code = charge.chargeCode;
                charge.taxCode = tax;
                delete charge.chargeCode;
                return charge;
            })
        }
        if(line["kunyeNo"] == null){
            line["kunyeNo"] = ""
        }
        if(line["malSahibi"] == null){
            line["malSahibi"] = ""
        }
        if(line["malSahibiVkntckn"] == null){
            line["malSahibiVkntckn"] = ""
        }

        return line;
    })
    outbox["trdDocVoucherLines"]= outbox.trdDocVoucherLines;
    outbox["taxCurrencyCode"]= outbox.documentCurrencyCode;

    outbox["from"] = DocumentFrom.CONNECTOR;
    return outbox;
}

export function readCustomer(key) {
    if (!key) {
        return Promise.resolve({options: []});
    } else {
        if (key.length >= 1) {
            let params = {
                url: `/connector/readCustomer`,
                method: "post",
                data: key
            };
            return request(params)
                .then(response => {
                    let cariList = response.data.return;
                    let options = cariList.map(cari => ({
                        value: cari.vknTckn,
                        label:  cari.cariCode +"-"+cari.vknTckn +"-"+ cari.formattedName,
                        cari
                    }));
                    return {options};
                })
                .catch(function (error) {
                    showAxiosError(error);
                });
        } else {
            return Promise.resolve({options: []});
        }
    }
}

export function wsSend (connectionInfo,ws,query,queryType,documentUuid){
    let header = {
        customerId: connectionInfo.customerId,
        dataSource: connectionInfo.dataSource,
        initialCatalog: connectionInfo.initialCatalog,
        dbUser: connectionInfo.dbUser,
        dbPassword: connectionInfo.dbPassword,
        key: connectionInfo.key,
        branchId: connectionInfo.branchId,
        clientType:"PORTAL"
    }
    let body = {
        uuid:documentUuid?documentUuid: uuidGenerator(),
        queryType: queryType,
        query: query
    };

    let jsonMsg = JSON.stringify({header,body})
    ws.send(jsonMsg);
}

export function uuidGenerator() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}
